import apiClient from "../../../utils/interceptor";
import { API_URLS } from "../../../constants";

// Get yards by company ID
export const getYardsByCompanyId = async (companyId) => {
    try {
        const response = await apiClient.get(
            `${API_URLS.YARD.GET_YARDS_BY_COMPANY_ID}/${companyId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching yards:", error);
        throw error;
    }
};

export const getSiteTypes = async () => {
    try {
        const response = await apiClient.get(API_URLS.YARD.GET_SITE_TYPES);
        return response.data;
    } catch (error) {
        console.error("Error fetching site types:", error);
        throw error;
    }
};

// Create yard
export const createYard = async (yardParams) => {
    try {
        const response = await apiClient.post(
            API_URLS.YARD.CREATE_YARD,
            yardParams
        );
        return response.data;
    } catch (error) {
        console.error("Error creating yard:", error);
        throw error;
    }
};

// Update yard
export const updateYard = async (yardData) => {
    try {
        const response = await apiClient.patch(
            API_URLS.YARD.UPDATE_YARD,
            yardData
        );
        return response.data;
    } catch (error) {
        console.error("Error updating yard:", error);
        throw error;
    }
};

// Delete yard
export const deleteYard = async (yardId) => {
    try {
        const response = await apiClient.delete(
            API_URLS.YARD.DELETE_YARD,
            {
                data: { yard_id: yardId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting yard:", error);
        throw error;
    }
};
